<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="casinoBetList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-3">
            <div
              v-if="totalPlayers"
              class="d-flex align-center"
            >
              <v-icon left>mdi-slot-machine</v-icon>
              <span>{{ totalPlayers }}</span>

              <span class="ml-2">
                {{ $tc("resultsPlurals", totalPlayers) }}
              </span>

              <v-progress-circular
                v-if="fetchingPlayers"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>

        <!-- ID's -->
        <template v-slot:[`item.player_id`]="{ item }">
          <v-btn x-small @click="$copy(item.player_id)">
            {{ item.player_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.affiliate_id`]="{ item }">
          <div v-if="item.affiliate_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.affiliate_id)" x-small>
            {{ item.affiliate_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.affiliate_name`]="{ item }">
          {{ item.affiliate_name || "-" }}
        </template>

        <template v-slot:[`item.local_id`]="{ item }">
          <div v-if="item.local_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.local_id)" x-small>
            {{ item.local_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.local_name`]="{ item }">
          {{ item.local_name || "-" }}
        </template>

        <!-- datas e horários -->
        <template v-slot:[`item.player_birthdate`]="{ item }">
          {{ $handleDate(item.player_birthdate).date }}
        </template>
        <template v-slot:[`item.player_register`]="{ item }">
          {{ $handleDate(item.player_register).date }}
        </template>
        <template v-slot:[`item.casino_reference_day`]="{ item }">
          {{ $handleDate(item.casino_reference_day).date }}
        </template>

        <!-- Valores de quantidade -->
        <template v-slot:[`item.bet_qtt`]="{ item }">
          <div class="text-end">
            {{ item.bet_qtt }}
          </div>
        </template>

        <template v-slot:[`item.bet_amount`]="{ item }">
          <div class="text-end green--text">{{ item.bet_amount }}</div>
        </template>

        <template v-slot:[`item.bet_refund_qtt`]="{ item }">
          <div class="text-end">
            {{ item.bet_refund_qtt }}
          </div>
        </template>

        <template v-slot:[`item.bet_refund_amount`]="{ item }">
          <div
            class="text-end"
            :class="item.bet_refund_amount > 0
              ? 'red--text'
              : 'grey--text'"
          >
            {{ item.bet_refund_amount }}
          </div>
        </template>

        <template v-slot:[`item.prize_qtt`]="{ item }">
          <div class="text-end">
            {{ item.prize_qtt }}
          </div>
        </template>

        <template v-slot:[`item.prize_amount`]="{ item }">
          <div
            class="text-end"
            :class="item.prize_amount > 0
              ? 'red--text'
              : 'grey--text'"
          >
            {{ item.prize_amount }}
          </div>
        </template>

        <template v-slot:[`item.prize_refund_qtt`]="{ item }">
          <div class="text-end">
            {{ item.prize_refund_qtt }}
          </div>
        </template>

        <template v-slot:[`item.prize_refund_amount`]="{ item }">
          <div
            class="text-end"
            :class="item.prize_refund_amount > 0
              ? 'red--text'
              : 'grey--text'"
          >
            {{ item.prize_refund_amount }}
          </div>
        </template>

        <template v-slot:[`item.prize_freespins_qtt`]="{ item }">
          <div class="text-end">
            {{ item.prize_freespins_qtt }}
          </div>
        </template>

        <template v-slot:[`item.prize_freespins_amount`]="{ item }">
          <div
            class="text-end"
            :class="item.prize_freespins_amount > 0
              ? 'red--text'
              : 'grey--text'"
          >
            {{ item.prize_freespins_amount }}
          </div>
        </template>
      </v-data-table>

      <v-pagination
        v-if="pageCount > 0 && casinoBetList && casinoBetList.length > 0"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="pb-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-apostas-cassino",
  data: (vm) => ({
    loading: false,
    fetchingPlayers: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    cachedPage: {},
    search: "",
    totalPlayers: 0,
    headers: [
      {text: vm.$t("playerId"), value: "player_id", align: "no-wrap"},
      {text: vm.$t("name"), value: "player_name", align: "no-wrap"},
      {text: "DDD", value: "player_ddd", align: "no-wrap"},
      {text: vm.$t("phone"), value: "player_phone", align: "no-wrap"},
      {text: "Login", value: "player_login", align: "no-wrap"},
      {text: "CPF", value: "player_document", align: "no-wrap"},
      {text: "Email", value: "player_email", align: "no-wrap"},
      {text: vm.$t("birthday"), value: "player_birthdate", align: "no-wrap"},
      {text: vm.$t("registrationDate"), value: "player_register", align: "no-wrap"},
      {text: vm.$t("gameId"), value: "game_id", align: "no-wrap"},
      {text: vm.$t("gameName"), value: "game_name", align: "no-wrap"},
      {text: vm.$t("qtyBets"), value: "bet_qtt", align: "no-wrap"},
      {text: vm.$t("bets"), value: "bet_amount", align: "no-wrap"},
      {text: vm.$t("betRefundQtt"), value: "bet_refund_qtt", align: "no-wrap"},
      {text: vm.$t("betRefundAmount"), value: "bet_refund_amount", align: "no-wrap"},
      {text: vm.$t("betsPrizeQty"), value: "prize_qtt", align: "no-wrap"},
      {text: vm.$t("totalPrizesValue"), value: "prize_amount", align: "no-wrap"},
      {text: vm.$t("prizeRefundQtt"), value: "prize_refund_qtt", align: "no-wrap"},
      {text: vm.$t("prizeRefundAmount"), value: "prize_refund_amount", align: "no-wrap"},
      {text: vm.$t("prizeFreespinsQtt"), value: "prize_freespins_qtt", align: "no-wrap"},
      {text: vm.$t("prizeFreespinsAmount"), value: "prize_freespins_amount", align: "no-wrap"},
      {text: vm.$t("casinoReferenceDay"), value: "casino_reference_day", align: "no-wrap"},
      {text: vm.$t("idAffiliate"), value: "affiliate_id", align: "no-wrap"},
      {text: vm.$t("affiliateName"), value: "affiliate_name", align: "no-wrap"},
      {text: vm.$t("localManagerId"), value: "local_id", align: "no-wrap"},
      {text: vm.$t("localManagerName"), value: "local_name", align: "no-wrap"},
    ],
    casinoBetList: [],
    latestRangeDate: {},
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDateHasChanged() {
      if (!this.latestRangeDate.data_inicio) return false;
      return this.latestRangeDate.data_inicio != this.rangeDate.data_inicio ||
        this.latestRangeDate.data_final != this.rangeDate.data_final
    }
  },

  watch: {
    rangeDate() {
      this.debouncedfetchTotalPlayersByGamesCassino();
    },
    saveFilters(bool) {
      bool && this.fetchCasinoBetsReport();
    },
    page() {
      this.fetchCasinoBetsReport(true);
    },
    totalPlayers(players) {
      if (players == 0) {
        this.casinoBetList = [];
      }
    }
  },

  mounted() {
    this.debouncedfetchTotalPlayersByGamesCassino();
  },

  methods: {
    debouncedfetchTotalPlayersByGamesCassino() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(()=> {this.fetchTotalPlayersByGamesCassino()}, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalPlayersByGamesCassino() {
      this.fetchingPlayers = true;
      const body = {
        ...this.rangeDate,
      }
      await this.$axios
        .post(`${this.$prefix()}/players/countPlayersByGamesCasino`, this.$formdata(body))
        .then((response) => {
          this.totalPlayers = Number(response.data.dados.players_by_games);
          this.pageCount = Math.ceil(this.totalPlayers / 100);
          this.fetchingPlayers = false;
        }).catch(() => this.fetchingPlayers = false);
    },

    async fetchCasinoBetsReport(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      }

      if (this.exportDoc && !isChangingPage) {
        body.isZip = true;
        await this.$request.exportDoc(
          `${this.$prefix()}/players/casinoGamesByPlayerReport`,
          body,
          this.exportDoc,
          this.rangeDate
        );
        return
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.casinoBetList = []
      
      if (this.cachedPage[this.page] && !this.rangeDateHasChanged) {
        this.casinoBetList = this.cachedPage[this.page]
        this.loading = false;
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        return
      }

      await this.$request
        .post(
          `${this.$prefix()}/players/casinoGamesByPlayerReport`, body
        )
        .then((resp) => {
          this.casinoBetList = resp.dados;
          this.cachedPage[this.page] = this.casinoBetList;
          this.loading = false;
          this.latestRangeDate = {...this.rangeDate}
        })
        .catch(() => {
          this.casinoBetList = [];
          this.loading = false;
        });
    },
  }
}
</script>